import React from 'react';
import { useCountdown } from '../hooks/useCountDown';
import DateTimeDisplay from './DateTimeDisplay';
import '../scss/countdown.scss';

const ExpiredNotice = () => {
  return (
    <div className="expired-notice">
      <span>Expired!!!</span>
      <p>Please select a future date and time.</p>
    </div>
  );
};

const ShowCounter = ({ days, hours, minutes, seconds }) => {
  return (
    <div className="show-counter">
      <DateTimeDisplay value={days} type={'j'} isDanger={days <= 3} />
      <DateTimeDisplay value={hours} type={'h'} isDanger={false} />
      <DateTimeDisplay value={minutes} type={'min'} isDanger={false} />
      <DateTimeDisplay value={seconds} type={'s'} isDanger={false} />
    </div>
  );
};

const CountdownTimer = ({ targetDate }) => {
  const [days, hours, minutes, seconds] = useCountdown(targetDate);

  if (days + hours + minutes + seconds <= 0) {
    return <ExpiredNotice />;
  } else {
    return (
      <ShowCounter
        days={days}
        hours={hours}
        minutes={minutes}
        seconds={seconds}
      />
    );
  }
};

export default CountdownTimer;